import { useEffect, useRef } from "react";
import { refreshCookieMode } from "../config/authMode";
import { RouterProvider } from "react-router";
import { useUserStatus } from "../hooks/useAuth";
import { useAuthStore } from "../store/useAuthStore";
import { AppUpdateModal } from "./components/AppUpdateModal";
import { router } from "./routes";
import { ChatProvider } from "../chat/ChatProvider";

export default function App() {
  const getUserStatus = useUserStatus();
  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    // Only ask the backend who we are if we actually have a session. Guests
    // would otherwise trigger a guaranteed 401 on /auth/status (plus a
    // pointless token-refresh attempt) on every page load.
    const { accessToken, refreshToken, isAuthenticated } = useAuthStore.getState();
    // Cookie mode keeps no token across reloads: a remembered session asks the server (401 → cookie refresh).
    if (accessToken || refreshToken || (refreshCookieMode && isAuthenticated)) {
      getUserStatus.mutate();
    }
  }, []);
  return (
    <ChatProvider>
      <RouterProvider router={router} />
      {/* Native-only version gate; renders nothing on the website. */}
      <AppUpdateModal />
    </ChatProvider>
  );
}
